import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import get from 'lodash/get';
import { selectVulnDetail } from 'store/ManageGeneral/selectors';
import { selectAllowedByRole } from 'Hooks/usePermission/selector';
import { FEATURE_VULNS, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';
import { selectWorkspaces } from 'store/Faraday/selectors';
import { updateVulnGeneral } from 'store/ManageGeneral/actions';
import { Input } from 'Common/Components/StandardTextField/styled';
import ExpandableWrapper from '../ExpandableWrapper';
import useExpandable from 'Hooks/useExpandable';
import Wrapper from 'Screens/Contextualization/Manage/components/VulnerabilityDetail/components/Tabs/components/GeneralTab/components/ExternalId/styled';

const TAB = 'general';
const ID = 'externalID';

const ExternalId = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const currentVuln = useSelector(selectVulnDetail);
  const externalId = get(currentVuln, 'external_id', '');
  const isExpanded = useExpandable(TAB, ID, externalId, currentVuln?._id);
  const canUpdate = useSelector((state) => selectAllowedByRole(state, FEATURE_VULNS, PERMISSION_TYPES.UPDATE));
  const workspaces = useSelector(selectWorkspaces);
  const vulnWorkspace = workspaces.find((ws) => ws.name === get(currentVuln, 'workspace_name', ''));
  const isVulnWorkspaceReadOnly = get(vulnWorkspace, 'readonly', false);
  const disabled = !canUpdate || isVulnWorkspaceReadOnly;

  const [localValue, setLocalValue] = useState(externalId || '');
  useEffect(() => {
    setLocalValue(externalId || '');
  }, [externalId]);

  const onBlur = (e) => {
    const newValue = e.target.value;
    if (newValue !== (externalId || '')) dispatch(updateVulnGeneral(currentVuln, 'external_id', newValue));
  };

  return (
    <ExpandableWrapper defaultValue={ isExpanded } title={ intl.formatMessage({ id: 'manage.detail.tab.general.externalID' }) } tab={ TAB } id={ ID }>
      <Wrapper>
        <Input
          value={ localValue }
          onChange={ (e) => setLocalValue(e.target.value) }
          onBlur={ onBlur }
          disabled={ disabled }
          name="external_id"
        />
      </Wrapper>
    </ExpandableWrapper>
  );
};

export default ExternalId;
